import React from "react";
import { connect, useDispatch } from "react-redux";
import { bool } from "prop-types";
import { ResponsiveHeader } from "pages/_components/header";
import Button from "pages/_components/Button";
import { goBack } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import * as i18nUtils from "util/i18n";

const StepScanDocumentTermsMigration = ({ isMobile }) => {
    const dispatch = useDispatch();

    return (
        <>
            {isMobile && <ResponsiveHeader ticket id="onboarding.vu.terms.title" />}
            {isMobile && (
                <MainContainer>
                    <div>
                        <p>{i18nUtils.get("onboarding.vu.terms")}</p>
                    </div>
                    <div className="form-actions">
                        <Button
                            label="global.accept"
                            bsStyle="primary"
                            onClick={() => {
                                dispatch(onboardingActions.setAcceptRenaperTerms(true));
                                dispatch(goBack());
                            }}
                            block
                        />
                        <Button
                            label="global.cancel"
                            bsStyle="outline"
                            onClick={() => {
                                dispatch(goBack());
                            }}
                            block
                        />
                    </div>
                </MainContainer>
            )}
        </>
    );
};

StepScanDocumentTermsMigration.propTypes = {
    isMobile: bool.isRequired,
};

StepScanDocumentTermsMigration.defaultProps = {};

const mapStateToProps = (state) => ({
    fetching: onboardingSelectors.getFetching(state),
});

export default connect(mapStateToProps)(StepScanDocumentTermsMigration);
